goog.provide("shadow.js.shim.module$react_masonry_component$default");
shadow.js.shim.module$react_masonry_component$default = shadow.js.shim.module$react_masonry_component.default;
